import { CombinedCustomerSummary, CombinedSummary } from "./types";

function insertPeopleIntoBranch(
  combined: CombinedSummary,
  companyId: string,
  branchId: number,
  branchPeople: CombinedCustomerSummary[]
): CombinedSummary {
  const result = { ...combined };
  const company = result[companyId] || {};
  let branch = company.branches.filter((b: any) => b.id === branchId)[0] || {};
  branch = { ...branch, customers: branchPeople };
  company.branches = company.branches.map((b: any) => {
    if (b.id === branchId) {
      return branch;
    }
    return b;
  });
  return result;
}

export default insertPeopleIntoBranch;
